export default __webpack_public_path__ + "static/media/mdi_address-marker.0c2aa523.svg";